/**
 * 결제책임 모달 (BS)
 * BS.open({ target, data: { ...ORDER, onApply } }) 로 호출.
 * apply() 시 this.parent.close() + onApply 콜백.
 */
export default class HowToPayModal {
    constructor() {
        this.id = null;
        this.parent = null;
        this.data = null;
    }

    getHtml = function(){
        return `
<div id="window-howtopay" class="order_responsibility">
    <p>결제책임선택</p>
    <div class="division_2 flex" id="window-howtopay-m">
        <div class="item flex" data-value="1">싸인</div>
        <div class="item flex" data-value="2">직수</div>
        <div class="item flex" data-value="5">카드</div>
    </div>

    <div id="window-howtopay-n">
        <p class="date">결제날짜선택</p>
        <div class="flex_column">
            <div class="flex division_4">
                <div class="item flex" data-value="1">당일</div>
                <div class="item flex" data-value="2">이틀</div>
                <div class="item flex" data-value="7">7일</div>
                <div class="item flex" data-value="15">중순</div>
            </div>
            <div class="flex division_4">
                <div class="item flex" data-value="30">월말</div>
                <div class="item flex" data-value="40">익월초</div>
                <div class="item flex" data-value="60">익월말</div>
                <div class="item flex" data-value="90">익익월말</div>
            </div>
        </div>
    </div>
</div>`;
    }

    init = function() {
        this.parent.setTitle('결제 방식');
        $('#' + this.id).html(this.getHtml());
        this.draw();
        this.initHandler();
    }

    destroy() {
        $('#window-howtopay').off();
    }

    initHandler = function(){
        const self = this;
        $('#window-howtopay-m .item').off().on('click',function(){
            let v = $(this).attr('data-value');
            self.data['howtopay']=v;
            self.draw();
            if( v>=2 ) {// 직수,카드일때만
                self.apply();
            }
        });
        $('#window-howtopay-n .item').off().on('click',function(){
            let v = $(this).attr('data-value');
            self.data['sign_howlong_int']=v;
            self.draw();
            self.apply();
        });
    }

    draw = function(){
        let m = this.data['howtopay'];
        let n = this.data['sign_howlong_int'];
        if( m==1) {
            $('#window-howtopay-n').show();
        }else{
            $('#window-howtopay-n').hide();
        }

        $('#window-howtopay-m .item').each(function(idx,el){
            // 발주자는 싸인 버튼을 안보이게
            if( MEMBER['mem_driver_type']=='발주자' && $(el).attr('data-value')==1) {
                $(el).hide();
            }

            if( $(el).attr('data-value')!=m ) $(el).removeClass('on');
            else $(el).addClass('on');
        });
        $('#window-howtopay-n .item').each(function(idx,el){
            if( $(el).attr('data-value')!=n ) $(el).removeClass('on');
            else $(el).addClass('on');
        });
    }

    apply = function(){
        // close 호출하지 않음 — onApply 가 다음 단계 BS 로 전환(또는 종료) 책임짐
        const cb = this.data?.onApply;
        if (typeof cb === 'function') cb(this.data);
    }
}
